export default __webpack_public_path__ + "static/media/VAPOR-BNB.72434c76.png";